import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import olympiadService from '../../services/olympiad.service';
import models_V2Service from '../../services/models_V2.service';
import ComponentTable from '../ComponentTable';
import { Box } from '@mui/material';

export default function AllTimeOlympiadChampions() {
    const { t } = useTranslation();

    return (
        <Fragment>
            <h2 className="container-header">{t('olympiad.olympiadChampionsAllTime')}</h2>
            <Box sx={{ pb: 2 }}>
                <ComponentTable
                    source={{
                        getData: (page, size, sort, filter) =>
                            olympiadService.GetAllOlympiadChampions(false, {
                                page: page || 0,
                                size: size || 10,
                                orderBy: (sort && sort.orderBy) || null,
                                order: (sort && sort.order) || 'asc',
                                filter,
                            }),
                        getModel: () => models_V2Service.getOlympiadChampions(false),
                    }}
                    actions={[]}
                    selectable={true}
                    enableFilter
                    title={t('modals.list')}
                    enableSettings
                    toolbarvisible={true}
                    typeTable="AllOlympiadChampions"
                />
            </Box>
        </Fragment>
    );
}
